import { useEffect } from "react";

export const usePreventScroll = (isOpen: boolean) => {
  useEffect(() => {
    if (isOpen) {
      const scrollPosition = window.scrollY;

      document.body.style.overflow = "hidden";
      document.body.style.position = "fixed";
      document.body.style.width = "100%";
      document.body.style.top = `-${scrollPosition}px`;

      return () => {
        document.body.style.overflow = "";
        document.body.style.position = "";
        document.body.style.width = "";
        document.body.style.top = "";
        window.scrollTo(0, scrollPosition);
      };
    }
    return;
  }, [isOpen]);
};
